module.exports = __webpack_public_path__ + "img/c06_unitmountedarcher_Normal_ua.b51c7681.webp";